import React from "react";
import bgImage from "../../images/bg/bootcamp-bg.png";
import { Link, useLocation } from "react-router-dom";

interface PageTitleProps {
  pageTitle: string;
  pagesub?: string;
}

const PATH_LABELS: Record<string, string> = {
  services: "Services",
  service: "Services",
  solutions: "Solutions",
  about: "About Us",
  team: "Our Leadership",
  blog: "Insights & Articles",
  insights: "Insights & Articles",
  resources: "Resources",
  career: "Careers",
  project: "Projects",
  industries: "Industries",
  tapeouts: "Tapeout Experience",
  contact: "Contact Us",
  "case-studies": "Case Studies",
  "why-digicomm": "Why Digicomm",
};

const formatSegment = (segment: string) => {
  if (PATH_LABELS[segment]) return PATH_LABELS[segment];

  return segment
    .split("-")
    .filter(Boolean)
    .map((word) => {
      const upper = word.toUpperCase();
      if (["ASIC", "SOC", "DFT", "EDA", "FPGA", "STA", "IP"].includes(upper)) {
        return upper === "SOC" ? "SoC" : upper;
      }
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(" ");
};

const PageTitle: React.FC<PageTitleProps> = ({ pageTitle, pagesub }) => {
  const { pathname } = useLocation();
  const segments = pathname.split("/").filter(Boolean);

  const breadcrumbItems = segments.map((segment, index) => {
    const isLast = index === segments.length - 1;
    const label = isLast ? pagesub || pageTitle : formatSegment(segment);
    const path = `/${segments.slice(0, index + 1).join("/")}`;
    return { label, path, isLast };
  });

  return (
    <section
      className="breadcrumb bg_img"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="container">
        <div className="breadcrumb__content">
          <ul className="breadcrumb__list clearfix list-unstyled">
            <li className="breadcrumb-item">
              <Link to="/home">Home</Link>
            </li>

            {breadcrumbItems.map((item) => (
              <li className="breadcrumb-item" key={item.path}>
                {item.isLast ? item.label : <Link to={item.path}>{item.label}</Link>}
              </li>
            ))}
          </ul>

          {pageTitle && <h2 className="breadcrumb__title">{pageTitle}</h2>}
        </div>
      </div>
    </section>
  );
};

export default PageTitle;
